import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Checkbox, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const CustomSelect = ({
  options = [
    { id: "Any", label: "Any", value: "Any" },
    { id: "Fax", label: "Fax", value: "Fax" },
    { id: "Animal", label: "Animal", value: "Animal" },
  ],
  width = 150,
  fieldName = "",
  selectedValue = { id: "Any", label: "Any", value: "Any" },
  handleChangeSelection = () => {},
  editPermission = true,
  groupBy = "Menu Name",
  disabled = false,
}) => {
  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState(selectedValue.label);

  const [filteredOptions, setFilteredOptions] = useState(options);

  const handleChange = (newValue) => {
    setValue(newValue);
    handleChangeSelection(newValue);
  };

  const handleInputChange = (newInputValue) => {
    const filtered = newInputValue
      ? options.filter((option) =>
          option.label
            .toLocaleLowerCase()
            .includes(newInputValue.toLocaleLowerCase())
        )
      : options;
    setInputValue(newInputValue);
    setFilteredOptions(filtered);
  };

  useEffect(() => {
    setValue(selectedValue);
    setInputValue(selectedValue.label);
  }, [selectedValue]);

  useEffect(() => setFilteredOptions(options), [options]);
  return (
    <Autocomplete
      // disablePortal
      id="combo-box-demo"
      options={filteredOptions}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      sx={{
        width: width,
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={fieldName}
          sx={{
            ".MuiFormLabel-root": { color: "#50566E" },
            "& .MuiInputBase-root": {
              backgroundColor: "#ffffff",
              borderRadius: "4px",
              color: "#1C2238",
              fontSize: ".875rem",
              fontWeight: 550,
              "& fieldset": {
                borderColor: "#D3D8E3",
              },
              "&:hover fieldset": {
                borderColor: "#D3D8E3",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#D3D8E3",
              },
            },
          }}
          size="small"
          variant="outlined"
        />
      )}
      onChange={(event, newValue) => {
        handleChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        handleInputChange(newInputValue);
      }}
      value={value}
      inputValue={inputValue}
      disableClearable
      popupIcon={<ExpandMoreIcon size="small" />}
      disabled={!editPermission || disabled}
      groupBy={() => groupBy}
      renderOption={(props, option, { selected }) => (
        <Box
          component="li"
          {...props}
          sx={{ paddingLeft: "0px", marginLeft: "0px" }}
        >
          <Checkbox
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            sx={{
              color: selected ? "#1492AF" : "",
              height: "28px",
              width: "32px",
            }}
            checked={selected}
          />
          {option.label}
        </Box>
      )}
      filterOptions={(options) =>
        options.filter((option) => option.id !== "SELECT")
      }
    />
  );
};

export default CustomSelect;
